import React from 'react';
import styled from 'styled-components';

export enum JiraPriority {
  Low = 'Low',
  Medium = 'Medium',
  High = 'High',
  'Very High' = 'Very High'
}

export const PriorityStyles: { [key: string]: string } = Object.freeze({
  Low: 'color: #4caf50; border-color: #4caf50;',
  Medium: 'color: #ffc107; border-color: #ffc107;',
  High: 'color: #ff4400; border-color: #ff4400;',
  'Very High': 'color: #ff0000; border-color: #ff0000;'
});

export interface StyledPillProps {
  priority: JiraPriority;
}

const StyledPill = styled.div<StyledPillProps>`
  width: 90px;
  border-radius: 4px;
  border-width: 2px;
  border-style: solid;
  text-align: center;
  ${({ priority }) => PriorityStyles[JiraPriority[priority]]}
`;

export interface JiraPillProps {
  priority: JiraPriority;
}

export const JiraPill: React.FC<JiraPillProps> = ({ priority }) => {
  if (!priority) return null;
  return (
    <StyledPill priority={priority}>{`${JiraPriority[priority]}`}</StyledPill>
  );
};

export default JiraPill;
